import React from 'react';
// import { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import AddCard from "../Widgets/Card2";
import SectionHeading from "../Widgets/section-head";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// @ts-ignore
import offers from "../../json-placeholders/special-offer.json";

import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";

const useStyles = makeStyles((theme) => ({
    wrapper: {
        padding: "6rem 2rem",
        background: "var(--primary)"
    },
}));

export default function SpecialOffers(props) {
    const classes = useStyles();

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        prevArrow: <IoMdArrowBack/>,
        nextArrow: <IoMdArrowForward/>,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    };

    return (
        <div className={classes.wrapper}>
            <SectionHeading text="Special offers" />
            <Slider {...settings} className={` special-offer`}>
                {offers.map(item=> {
                    return <AddCard key={item.id} data={item} />
                })}
            </Slider>
        </div>
    );
}
